import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
    title = "브로넥스 | 스마트 팩토리 솔루션 전문 기업 - MES, QMS, ACS",
    description = "Smart Factory 기술의 한계를 넘어, 고객의 비전을 현실로. 브로넥스의 MES, QMS, ACS 솔루션으로 공장을 최적화하세요. 스마트 팩토리 구축의 최고 파트너.",
    keywords = "스마트공장, 스마트팩토리, MES, QMS, ACS, 생산관리시스템, 품질관리시스템, 설비관리, 자율주행, 브로넥스, BROANEX, 공장자동화, 제조실행시스템, 생산관리, 품질관리",
    image = "https://www.broanex.com/img/og-image.jpg",
    url = "https://www.broanex.com",
}) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />

            {/* Canonical */}
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO;
